import {useNotificationStore} from "../stores/notification";
import dom from "@left4code/tw-starter/dist/js/dom";
import {createIcons, icons} from "lucide";
import dayjs from "dayjs";
import axios from "axios";
import authHeader from "../services/auth-header";

export default {

    methods: {

        userHasRole: function(roles) {
            if (roles == null || roles.length < 1) {
                return true;
            }

            let found = false;
            let user = this.$store.getters['auth/user'];

            if (user == null) {
                found = false;
            } else {
                roles.forEach((role) => {
                    if (user.roles.find(x => x.name === role) != null) {
                        found = true;
                    }
                })
            }

            return found;
        },

        reInitOnResizeWindow: function () {
            window.addEventListener("resize", () => {
                this.tabulator.redraw();
                this.updateIcons();
            });
        },

        dateFormat: function (date) {
            if (date == null) {
                return '-';
            }
            return dayjs(date).format('DD.MM.YYYY');
        },

        openAuthenticatedDownload: async function (url, options = {}) {
            // Open the preview while the click still counts as a user action.
            // Otherwise browsers may block the new tab after the request finishes.
            const previewWindow = options.download ? null : window.open('', '_blank');

            try {
                const response = await axios.get(url, {
                    headers: authHeader(),
                    responseType: 'blob'
                });
                const objectUrl = URL.createObjectURL(response.data);
                const disposition = response.headers['content-disposition'] || '';
                const encodedFilename = disposition.match(/filename\*=UTF-8''([^;]+)/i);
                const filename = options.filename
                    || (encodedFilename ? decodeURIComponent(encodedFilename[1]) : null)
                    || disposition.match(/filename="?([^";]+)"?/i)?.[1];

                if (previewWindow) {
                    previewWindow.opener = null;
                    previewWindow.location.replace(objectUrl);
                } else {
                    const link = document.createElement('a');
                    link.href = objectUrl;
                    link.download = filename || 'download';
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }

                window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
            } catch (error) {
                if (previewWindow) {
                    previewWindow.close();
                }

                this.showNotification(
                    true,
                    'Dokument konnte nicht geöffnet werden',
                    'Bitte versuchen Sie es erneut.'
                );
            }
        },

        updateIcons: function () {
            setTimeout(() => {
                createIcons({
                    icons,
                    color: '#fff',
                    "stroke-width": 2,
                    nameAttr: "data-lucide",
                });
            }, 200);
        },

        enableScrolling: function () {
            dom("body").removeClass("overflow-y-hidden");
        },

        showNotification: function (visible, text, description) {

            if (this.notificationStore == null) {
                this.notificationStore = useNotificationStore();
            }

            this.notificationStore.setVisible(visible);
            this.notificationStore.setText(text);
            this.notificationStore.setDescription(description);
        }
    }
};
